import { Card, Table, Tag, Badge, Tooltip, Space, DatePicker, Input, Select, Button, Empty, Tabs, Avatar } from 'antd'
import React, { useEffect, useState } from 'react'
import TitleHead from '../components/Customs/TitleHead'
import { RoomServices } from '../Services/RoomServices'
import {
  PhoneOutlined,
  MailOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  FilterOutlined,
  ClearOutlined,
} from '@ant-design/icons'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { navigate } from '../components/Customs/navigation'
import { GeneralService } from '../Services/GeneralService'
import booking_com from '../../assets/Booking.com.png'
import makemytrip from '../../assets/Makemytrip.png'
import self from '../../assets/brand.png'


import { canViewModule } from '../../utils/permissionUtils';

const MODULE_KEY = "online_booking";

dayjs.extend(isBetween)

const { RangePicker } = DatePicker
const { Search } = Input
const { Option } = Select

const statusConfig = {
  reserved: { color: 'blue', label: 'Reserved' },
  checked_in: { color: 'green', label: 'Checked In' },
  checked_out: { color: 'default', label: 'Checked Out' },
  cancelled: { color: 'red', label: 'Cancelled' },
}

const OnlineBookingPage = () => {
  const [order, setOrder] = useState([])
  const [filtered, setFiltered] = useState([])
  const [loading, setLoading] = useState(false)

  const [searchText, setSearchText] = useState('')
  const [dateRange, setDateRange] = useState(null)
  const [bookingDateRange, setBookingDateRange] = useState(null)
  const [statusFilter, setStatusFilter] = useState(null)
  const [paymentFilter, setPaymentFilter] = useState(null)
  const [orderSeenFilter, setOrderSeenFilter] = useState('all')
  const [check_time, setCheck_times] = useState({});
  const [selectedSource, setSelectedSource] = useState("self");

  const dummyBookings = {
    
    // booking: [
    //   {
    //     "id": 2001,
    //     "guest_name": "John Smith",
    //     "phone": "9876543210",
    //     "email": "catdzoro@gmail.com",
    //     "id_type": "Aadhar Card",
    //     "id_number": "098765435678",
    //     "address": "awkbegfkaewjrg",
    //     "guests": 1,
    //     "check_in": "2026-06-05",
    //     "check_out": "2026-06-06",
    //     "check_in_time": null,
    //     "check_out_time": null,
    //     "special_requests": "test ",
    //     "payment_mode": "Cash",
    //     "room_id": 57,
    //     "room_name": "Family Room ",
    //     "room_number": "202",
    //     "room_type": "Duplex",
    //     "floor": "2",
    //     "price_per_day": "1500.00",
    //     "price_per_hour": "100.00",
    //     "max_occupancy": 2,
    //     "add_cost_per_occupancy": "400.00",
    //     "rate_per_night": "1500.00",
    //     "duration_nights": 1,
    //     "base_total": "1500.00",
    //     "extra_guests": 0,
    //     "extra_cost_per_night": "0.00",
    //     "extra_total": "0.00",
    //     "total_amount": "1500.00",
    //     "created_at": "2026-06-05 18:56:29.283096+05:30",
    //     "update_at": "2026-06-05 18:56:29.283096+05:30",
    //     "guest_status": "reserved",
    //     "document_upload": "[]",
    //     "raw_data": {
    //       "guest_name": "tesui",
    //       "phone": "9876545678",
    //       "ac_required": false,
    //       "email": "catdzoro@gmail.com",
    //       "id_type": "Aadhar Card",
    //       "id_number": "098765435678",
    //       "address": "awkbegfkaewjrg",
    //       "guests": 1,
    //       "check_in": "2026-06-05",
    //       "check_out": "2026-06-06",
    //       "special_requests": "test ",
    //       "payment_mode": "Cash",
    //       "room_id": 57,
    //       "check_in_time": "12PM-11AM",
    //       "check_out_time": "12PM-11AM",
    //       "status": "reserved",
    //       "skip_room_status_update": false,
    //       "room_data": "{\"id\":57,\"title\":\"Family Room \",\"price\":1500,\"image\":\"\",\"max\":2,\"additional\":2,\"addCost\":400,\"room_name\":\"Family Room \",\"room_number\":\"202\",\"room_type\":\"Duplex\",\"floor\":\"2\",\"price_per_day\":\"1500.00\",\"price_per_hour\":\"100.00\",\"max_occupancy\":2,\"status\":\"available\",\"amenities\":\"[]\",\"description\":\"\",\"images\":\"[]\",\"added_on\":\"19-May-2026, 9:05:13 PM\",\"updated_on\":\"27-May-2026, 7:45:15 PM\",\"discount\":\"0\",\"review_rating\":\"5\",\"review_count\":\"89\",\"add_cost_per_occupancy\":\"400\",\"additional_occupancy\":\"2\",\"order_status\":null,\"ac_charge\":\"500\",\"sort_order\":\"13\",\"full_book\":null,\"additional_24_hour\":null,\"online_price\":null,\"guests\":1}",
    //       "pricing_summary": "{\"rate_per_night\":1500,\"duration_nights\":1,\"base_total\":1500,\"extra_guests\":0,\"extra_cost_per_night\":0,\"extra_total\":0,\"ac_charge_per_night\":0,\"ac_total\":0,\"total_amount\":1500}",
    //       "mode": "online"
    //     },
    //     "ac_check_out": null,
    //     "ac_check_out_time": null,
    //     "mode": "online",
    //     "payment_status": null,
    //     "expected_check_in": null,
    //     "paid_amount": null,
    //     "ac_required": "false",
    //     "pricing_summary": "{\"rate_per_night\":1500,\"duration_nights\":1,\"base_total\":1500,\"extra_guests\":0,\"extra_cost_per_night\":0,\"extra_total\":0,\"ac_charge_per_night\":0,\"ac_total\":0,\"total_amount\":1500}",
    //     "seen": false,
    //     "type": null,
    //     "customer_gst": null,
    //     "additional_24_hour": null,
    //     "full_book": null,
    //     "bl_id": 260
    //   }
    // ],
    // makemytrip: [
    //   {
    //     "id": 3001,
    //     "guest_name": "Amit Kumar",
    //     "phone": "9876543210",
    //     "email": "catdzoro@gmail.com",
    //     "id_type": "Aadhar Card",
    //     "id_number": "098765435678",
    //     "address": "awkbegfkaewjrg",
    //     "guests": 1,
    //     "check_in": "2026-06-05",
    //     "check_out": "2026-06-06",
    //     "check_in_time": null,
    //     "check_out_time": null,
    //     "special_requests": "test ",
    //     "payment_mode": "Cash",
    //     "room_id": 57,
    //     "room_name": "Family Room ",
    //     "room_number": "202",
    //     "room_type": "Duplex",
    //     "floor": "2",
    //     "price_per_day": "1500.00",
    //     "price_per_hour": "100.00",
    //     "max_occupancy": 2,
    //     "add_cost_per_occupancy": "400.00",
    //     "rate_per_night": "1500.00",
    //     "duration_nights": 1,
    //     "base_total": "1500.00",
    //     "extra_guests": 0,
    //     "extra_cost_per_night": "0.00",
    //     "extra_total": "0.00",
    //     "total_amount": "1500.00",
    //     "created_at": "2026-06-05 18:56:29.283096+05:30",
    //     "update_at": "2026-06-05 18:56:29.283096+05:30",
    //     "guest_status": "reserved",
    //     "document_upload": "[]",
    //     "raw_data": {
    //       "guest_name": "tesui",
    //       "phone": "9876545678",
    //       "ac_required": false,
    //       "email": "catdzoro@gmail.com",
    //       "id_type": "Aadhar Card",
    //       "id_number": "098765435678",
    //       "address": "awkbegfkaewjrg",
    //       "guests": 1,
    //       "check_in": "2026-06-05",
    //       "check_out": "2026-06-06",
    //       "special_requests": "test ",
    //       "payment_mode": "Cash",
    //       "room_id": 57,
    //       "check_in_time": "12PM-11AM",
    //       "check_out_time": "12PM-11AM",
    //       "status": "reserved",
    //       "skip_room_status_update": false,
    //       "room_data": "{\"id\":57,\"title\":\"Family Room \",\"price\":1500,\"image\":\"\",\"max\":2,\"additional\":2,\"addCost\":400,\"room_name\":\"Family Room \",\"room_number\":\"202\",\"room_type\":\"Duplex\",\"floor\":\"2\",\"price_per_day\":\"1500.00\",\"price_per_hour\":\"100.00\",\"max_occupancy\":2,\"status\":\"available\",\"amenities\":\"[]\",\"description\":\"\",\"images\":\"[]\",\"added_on\":\"19-May-2026, 9:05:13 PM\",\"updated_on\":\"27-May-2026, 7:45:15 PM\",\"discount\":\"0\",\"review_rating\":\"5\",\"review_count\":\"89\",\"add_cost_per_occupancy\":\"400\",\"additional_occupancy\":\"2\",\"order_status\":null,\"ac_charge\":\"500\",\"sort_order\":\"13\",\"full_book\":null,\"additional_24_hour\":null,\"online_price\":null,\"guests\":1}",
    //       "pricing_summary": "{\"rate_per_night\":1500,\"duration_nights\":1,\"base_total\":1500,\"extra_guests\":0,\"extra_cost_per_night\":0,\"extra_total\":0,\"ac_charge_per_night\":0,\"ac_total\":0,\"total_amount\":1500}",
    //       "mode": "online"
    //     },
    //     "ac_check_out": null,
    //     "ac_check_out_time": null,
    //     "mode": "online",
    //     "payment_status": null,
    //     "expected_check_in": null,
    //     "paid_amount": null,
    //     "ac_required": "false",
    //     "pricing_summary": "{\"rate_per_night\":1500,\"duration_nights\":1,\"base_total\":1500,\"extra_guests\":0,\"extra_cost_per_night\":0,\"extra_total\":0,\"ac_charge_per_night\":0,\"ac_total\":0,\"total_amount\":1500}",
    //     "seen": false,
    //     "type": null,
    //     "customer_gst": null,
    //     "additional_24_hour": null,
    //     "full_book": null,
    //     "bl_id": 260
    //   },
    // ],
  };

  const getCheckTime = async () => {
    try {

      const req = await RoomServices.getAllByTable('utills')

      const defaultData = {
        checkin: dayjs(req.data[0].checkin_time, 'hh:mm A'),
        checkout: dayjs(req.data[0].checkout_time, 'hh:mm A'),
      }

      setCheck_times(defaultData)

    } catch (error) {
      console.error(error);

    }
  }

  // seen = true  => NOT SEEN / unread
  // seen = false => SEEN / read
  const isUnread = (record) =>
    record.seen === true ||
    record.seen === 1 ||
    record.seen === 'true'

  const makeUniqueById = (data = []) => {
    return Array.from(
      new Map(data.map(item => [item.id, item])).values()
    )
  }

  const handleSourceChange = (key) => {
    console.log("Selected Source:", key);
    setSelectedSource(key);

    if (key === "self") {
      setFiltered(order);
      return;
    }

    setFiltered(dummyBookings[key] || []);
  };

  const sortBookings = (data = []) => {
    const uniqueData = makeUniqueById(data)

    return uniqueData.sort((a, b) => {
      const aUnread = isUnread(a)
      const bUnread = isUnread(b)

      if (aUnread && !bUnread) return -1
      if (!aUnread && bUnread) return 1

      return new Date(b.created_at) - new Date(a.created_at)
    })
  }

  const sortByLatestOnly = (data = []) =>
    makeUniqueById(data).sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    )

  const getOnlineOrder = async () => {
    setLoading(true)

    try {
      const req = await RoomServices.getOnlineOrdesr()
      const sorted = sortBookings(req.data || [])

      setOrder(sorted)
      setFiltered(sorted)

      console.log('sorted', sorted)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getOnlineOrder()
    getCheckTime()
  }, [])

  useEffect(() => {
    let data = [...order]

    if (searchText) {
      const q = searchText.toLowerCase()

      data = data.filter(r =>
        r.guest_name?.toLowerCase().includes(q) ||
        r.phone?.includes(q) ||
        r.email?.toLowerCase().includes(q) ||
        r.room_name?.toLowerCase().includes(q) ||
        r.room_number?.includes(q) ||
        r.id_number?.includes(q)
      )
    }

    if (dateRange?.[0] && dateRange?.[1]) {
      data = data.filter(r =>
        dayjs(r.check_in).isBetween(dateRange[0], dateRange[1], 'day', '[]')
      )
    }

    if (bookingDateRange?.[0] && bookingDateRange?.[1]) {
      data = data.filter(r =>
        dayjs(r.created_at).isBetween(bookingDateRange[0], bookingDateRange[1], 'day', '[]')
      )
    }

    if (statusFilter) {
      data = data.filter(r => r.guest_status === statusFilter)
    }

    if (paymentFilter) {
      data = data.filter(r => r.payment_mode === paymentFilter)
    }

    if (orderSeenFilter === 'unreaded') {
      data = data.filter(r => isUnread(r))
      setFiltered(sortByLatestOnly(data))
      return
    }

    if (orderSeenFilter === 'readed') {
      data = data.filter(r => !isUnread(r))
      setFiltered(sortByLatestOnly(data))
      return
    }

    setFiltered(sortBookings(data))
  }, [
    searchText,
    dateRange,
    bookingDateRange,
    statusFilter,
    paymentFilter,
    orderSeenFilter,
    order,
  ])

  const clearFilters = () => {
    setSearchText('')
    setDateRange(null)
    setBookingDateRange(null)
    setStatusFilter(null)
    setPaymentFilter(null)
    setOrderSeenFilter('all')
  }

  const hasActiveFilters =
    searchText ||
    dateRange ||
    bookingDateRange ||
    statusFilter ||
    paymentFilter ||
    orderSeenFilter !== 'all'

  const handleNavigate = async (record) => {
    await setRead(record.id)

    const req = {
      a: dayjs(check_time.checkin).format("hh:mm:ss A"),
      b: dayjs(check_time.checkout).format("hh:mm:ss A")
    }

    // navigate('/book-room/online', {
    navigate('/book-room/action', {
      state: {
        source: 'online_booking',
        booking: {
          ...record,
          seen: false,
          check_in_time: req.a,
          check_out_time: req.b,
        },
        room: {
          id: record.room_id,
          room_name: record.room_name,
          room_number: record.room_number,
          room_type: record.room_type,
          floor: record.floor,
          status: record.guest_status,
          price_per_day: record.price_per_day,
          max_occupancy: record.guests,
          additional_occupancy: 0,
          add_cost_per_occupancy: 0,
          amenities: '[]',
          description: '',
          ...record,
          seen: false,
        },

        check_time: req
      },
    })

    console.log(record)
  }

  const setRead = async (id) => {
    try {
      const req = await GeneralService.edit(id, 'book_room', { seen: false })
      console.log('req', req)

      setOrder(prev =>
        sortBookings(
          prev.map(item =>
            item.id === id
              ? { ...item, seen: false }
              : item
          )
        )
      )

      setFiltered(prev =>
        sortBookings(
          prev.map(item =>
            item.id === id
              ? { ...item, seen: false }
              : item
          )
        )
      )
    } catch (error) {
      console.error(error)
    }
  }

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 55,
      render: (_, __, index) => (
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: index === 0 ? '#e6f4ff' : '#f5f5f5',
          color: index === 0 ? '#1677ff' : '#8c8c8c',
          fontWeight: 600,
          fontSize: 12,
        }}>
          {index + 1}
        </span>
      ),
    },
    {
      title: 'Guest',
      key: 'guest',
      width: 200,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Space size={8}>
            <span style={{ fontWeight: 600, color: '#1a1a2e', fontSize: 13 }}>
              {record.guest_name}
            </span>
          </Space>

          <Space size={12}>
            <Tooltip title={record.phone}>
              <Space size={4} style={{ color: '#8c8c8c', fontSize: 11 }}>
                <PhoneOutlined />
                <span>{record.phone}</span>
              </Space>
            </Tooltip>
          </Space>

          <Space size={4}>
            <MailOutlined style={{ color: '#8c8c8c', fontSize: 11 }} />
            <span style={{ color: '#8c8c8c', fontSize: 11 }}>
              {record.email}
            </span>
          </Space>
        </Space>
      ),
    },
    {
      title: 'Room',
      key: 'room',
      width: 175,
      render: (_, record) => (
        <Space direction="vertical" size={2}>
          <Space size={6}>
            <span style={{ fontWeight: 600, fontSize: 13, color: '#1a1a2e' }}>
              {record.room_name}
            </span>
          </Space>

          <Space size={6}>
            <Tag color="geekblue" style={{ marginRight: 0, fontSize: 11 }}>
              #{record.room_number}
            </Tag>

            <Tag color="cyan" style={{ marginRight: 0, fontSize: 11 }}>
              Floor {record.floor}
            </Tag>

            <Tag color="red" style={{ marginRight: 0, fontSize: 11 }}>
              AC: {record.ac_required ? 'Required' : 'Not Required'}
            </Tag>
          </Space>

          <span style={{ fontSize: 11, color: '#8c8c8c' }}>
            {record.room_type}
          </span>
        </Space>
      ),
    },
    {
      title: 'Check-In / Check-Out',
      key: 'dates',
      width: 185,
      render: (_, record) => (
        <Space direction="vertical" size={4}>
          <Space size={6}>
            <CalendarOutlined style={{ color: '#52c41a' }} />
            <span style={{ fontSize: 12, color: '#389e0d', fontWeight: 500 }}>
              In: {record.check_in}
            </span>
          </Space>

          <Space size={6}>
            <CalendarOutlined style={{ color: '#ff4d4f' }} />
            <span style={{ fontSize: 12, color: '#cf1322', fontWeight: 500 }}>
              Out: {record.check_out}
            </span>
          </Space>

          <Space size={6}>
            <ClockCircleOutlined style={{ color: '#8c8c8c', fontSize: 11 }} />
            <span style={{ fontSize: 11, color: '#8c8c8c' }}>
              {record.duration_nights} night{record.duration_nights !== 1 ? 's' : ''}
            </span>
          </Space>
        </Space>
      ),
    },
    {
      title: 'Guests',
      key: 'guests',
      width: 90,
      align: 'center',
      render: (_, record) => (
        <Space direction="vertical" size={2} align="center">
          <Space size={4}>
            <TeamOutlined style={{ color: '#722ed1' }} />
            <span style={{ fontWeight: 700, fontSize: 16, color: '#531dab' }}>
              {record.guests}
            </span>
          </Space>

          {record.extra_guests > 0 && (
            <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>
              +{record.extra_guests} extra
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: 'Payment',
      key: 'payment',
      width: 155,
      render: (_, record) => (
        <Space direction="vertical" size={4}>
          <Space size={6}>
            <CreditCardOutlined style={{ color: '#fa8c16' }} />
            <Tag color="orange" style={{ marginRight: 0 }}>
              {record.payment_status}
            </Tag>
          </Space>

          <span style={{ fontWeight: 700, fontSize: 15, color: '#1a1a2e' }}>
            ₹{Number(record.total_amount || 0).toLocaleString('en-IN')}
          </span>

          <span style={{ fontSize: 11, color: '#8c8c8c' }}>
            ₹{Number(record.price_per_day || 0).toLocaleString('en-IN')}/night
          </span>
        </Space>
      ),
    },
    {
      title: 'ID Proof',
      key: 'id',
      width: 140,
      render: (_, record) => (
        <Space direction="vertical" size={2}>
          <Tag color="volcano" style={{ fontSize: 11 }}>
            {record.id_type}
          </Tag>

          <span style={{
            fontSize: 11,
            color: '#8c8c8c',
            fontFamily: 'monospace',
          }}>
            {record.id_number}
          </span>
        </Space>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      width: 115,
      align: 'center',
      render: (_, record) => {
        const cfg = statusConfig[record.guest_status] || {
          color: 'default',
          label: record.guest_status,
        }

        return (
          <Space direction="vertical" size={4} align="center">
            <Badge
              status={
                cfg.color === 'green'
                  ? 'success'
                  : cfg.color === 'blue'
                    ? 'processing'
                    : cfg.color === 'red'
                      ? 'error'
                      : 'default'
              }
              text={
                <Tag color={cfg.color} style={{ margin: 0, fontWeight: 600, fontSize: 12 }}>
                  {cfg.label}
                </Tag>
              }
            />

            <span style={{ fontSize: 10, color: '#b0b0b0' }}>
              {new Date(record.created_at).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: '2-digit',
              })}
            </span>
          </Space>
        )
      },
    },
    {
      title: 'Order Status',
      key: 'seen',
      width: 120,
      align: 'center',
      render: (_, record) =>
        isUnread(record) ? (
          <Tag color="red" style={{ fontWeight: 700 }}>Unreaded</Tag>
        ) : (
          <Tag color="green">Readed</Tag>
        ),
    },
    {
      title: 'Action',
      key: 'action',
      width: 115,
      align: 'center',
      render: (_, record) => (
        <Button
          type="primary"
          ghost
          onClick={() => handleNavigate(record)}
        >
          View
        </Button>
      ),
    },
  ]

  if (!canViewModule(MODULE_KEY)) {
    return <Empty description="No permission to view this page" />;
  }

  return (
    <Card
      title={
        <TitleHead
          h1="Online Bookings"
          h2="Manage online room bookings, guest details, and check-in/check-out activities"
        />
      }
      style={{ borderRadius: 12 }}
      styles={{ body: { padding: 0 } }}
    >
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #f0f0f0",
          background: "#fff",
        }}
      >
        <Tabs
          activeKey={selectedSource}
          onChange={handleSourceChange}
          items={[
            {
              key: "self",
              label: (
                <Space>
                  <Avatar

                    size={30}
                    src={self}
                  />
                  Self
                </Space>
              ),
            },
           
            {
              key: "booking",
              label: (
                <Space>
                  <Avatar
                    size={30}
                    src={booking_com}
                  />
                  Booking.com
                </Space>
              ),
            },
            {
              key: "makemytrip",
              label: (
                <Space>
                  <Avatar
                    size={30}
                    src={makemytrip}
                  />
                  MakeMyTrip
                </Space>
              ),
            },
          ]}
        />
      </div>

      <div style={{
        padding: '14px 16px',
        borderBottom: '1px solid #f0f0f0',
        background: '#fafcff',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        alignItems: 'center',
      }}>
        <FilterOutlined style={{ color: '#1677ff', fontSize: 15 }} />

        <Search
          placeholder="Search guest, phone, room…"
          allowClear
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          style={{ width: 220 }}
          size="middle"
        />

        <RangePicker
          placeholder={['Check-in From', 'Check-in To']}
          value={dateRange}
          onChange={setDateRange}
          size="middle"
          style={{ width: 280 }}
          format="DD MMM YYYY"
          allowClear
        />

        <RangePicker
          placeholder={['Booked From', 'Booked To']}
          value={bookingDateRange}
          onChange={setBookingDateRange}
          size="middle"
          style={{ width: 280 }}
          format="DD MMM YYYY"
          allowClear
          presets={[
            { label: 'Today', value: [dayjs(), dayjs()] },
            { label: 'Last 7 days', value: [dayjs().subtract(6, 'day'), dayjs()] },
            { label: 'This Month', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
          ]}
        />

        <Select
          placeholder="Status"
          allowClear
          value={statusFilter}
          onChange={setStatusFilter}
          style={{ width: 140 }}
          size="middle"
        >
          {Object.entries(statusConfig).map(([key, { label, color }]) => (
            <Option key={key} value={key}>
              <Tag color={color} style={{ margin: 0 }}>
                {label}
              </Tag>
            </Option>
          ))}
        </Select>

        <Select
          placeholder="Order Status"
          value={orderSeenFilter}
          onChange={setOrderSeenFilter}
          style={{ width: 150 }}
          size="middle"
        >
          <Option value="all">All</Option>
          <Option value="readed">Readed</Option>
          <Option value="unreaded">Unreaded</Option>
        </Select>

        {hasActiveFilters && (
          <Button
            icon={<ClearOutlined />}
            onClick={clearFilters}
            size="middle"
            style={{
              color: '#ff4d4f',
              borderColor: '#ffccc7',
              background: '#fff1f0',
            }}
          >
            Clear
          </Button>
        )}

        <span style={{
          marginLeft: 'auto',
          fontSize: 12,
          color: '#8c8c8c',
          fontWeight: 500,
        }}>
          {filtered.length} of {order.length} bookings
        </span>
      </div>

      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        loading={loading}
        scroll={{ x: 1100 }}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} bookings`,
          style: { padding: '12px 16px' },
        }}
        onRow={(record) => ({
          style: {
            background: isUnread(record) ? '#fff1f0' : undefined,
            fontWeight: isUnread(record) ? 600 : 400,
            transition: 'background 0.2s',
          },
        })}
        rowClassName={(record) => isUnread(record) ? 'unread-row' : ''}
        style={{ borderRadius: 12 }}
        size="middle"
        locale={{ emptyText: <Empty /> }}
      />

      <style>{`
        .ant-table-row:hover > td {
          background: #f5f9ff !important;
        }

        .ant-table-tbody > tr:first-child > td:first-child {
          border-left: 3px solid #1677ff;
        }

        .ant-table-thead > tr > th {
          background: #fafafa !important;
          font-weight: 700 !important;
          font-size: 12px !important;
          color: #595959 !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .ant-table-tbody > tr.unread-row > td {
          background: #fff1f0 !important;
        }

        .ant-table-tbody > tr.unread-row:hover > td {
          background: #ffe7e6 !important;
        }

        .ant-table-tbody > tr.unread-row > td:first-child {
          border-left: 4px solid #ff4d4f;
        }
      `}</style>
    </Card>
  )
}

export default OnlineBookingPage